<template>
  <tile-grid>
      <service-tile
        v-for="service in getErrorServices"
        :key="service.id"
        :selected="false"
        :service="service"
      />
  </tile-grid>
</template>

<script>
import { mapGetters } from 'vuex';
import BreadcrumbsManager from '@/mixins/BreadcrumbsManager';
import ServiceTile from '@/components/services/service/ServiceTile';
import TileGrid from '@/components/utils/TileGrid';

export default {
  name: 'ErrorServices',
  mixins: [
    BreadcrumbsManager,
  ],
  props: {
  },
  computed: {
    ...mapGetters([
      'getErrorServices',
    ]),
    breadcrumbs() {
      return [{
        text: this.$t('services-with-error'),
      }];
    },
  },
  components: {
    TileGrid,
    ServiceTile,
  },
};
</script>

<style scoped>

</style>
